import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { array, bool, func, object, string } from 'prop-types';
import Search from 'ps-components/Search/Search';
import FacetPanel from 'ps-components/FacetPanel/FacetPanel';
import AdvancedTable from 'ps-components/AdvancedTable/AdvancedTable';
import AdvancedCell from 'ps-components/AdvancedTable/AdvancedCell';
import SubLabelList from 'ps-components/SubLabelList/SubLabelList';
import Pagination from 'ps-components/Pagination/Pagination';
import CheckboxInput from 'ps-components/Input/CheckboxInput';
import moment from 'moment';
import './MarketPaySurveyLibrary.scss';
import classnames from 'classnames';
import AddNewSurveyModal from '../AddNewSurveyModal';
import isIE from 'ps-components/Utils/checkForIE';

function MarketPaySurveyLibrary(props) {
  const [selectedSurveys, setSelectedSurveys] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [shouldShowAddNewSurveyModal, setShouldShowAddNewSurveyModal] = useState(false);

  useEffect(() => {
    const { searchInputSearch } = props;
    if (!searchText) {
      searchInputSearch('');
    }
  }, []);

  function searchOnChange(event) {
    setSearchText(event?.target?.value);
  }

  function searchOnClick() {
    const { searchInputSearch } = props;
    setSearchText('');
    searchInputSearch('');
  }

  function searchOnKeyDown(event) {
    const { searchInputSearch } = props;
    if (event.key === 'Enter') {
      searchInputSearch(searchText);
    }
  }

  function searchOnSearch() {
    const { searchInputSearch } = props;
    searchInputSearch(searchText);
  }

  function pageSurveys(limit, offset) {
    const { pageList } = props;
    pageList(limit, offset);
  }

  const columnHeaders = [
    {
      Header: 'Survey',
      accessor: 'code'
    },
    {
      Header: 'Survey Jobs',
      width: 100,
      accessor: 'numSurveyJobs'
    },
    {
      Header: 'Participants',
      width: 100,
      accessor: 'numParticipants'
    },
    {
      Header: 'Data Cuts',
      width: 100,
      accessor: 'numJobScopes'
    },
    {
      Header: 'Effective Date',
      width: 100,
      accessor: 'effDate'
    }
  ];

  function getTableRows(row, rowIndex) {
    const isChecked =
      row.original.isAddedToSite ||
      selectedSurveys.find(selectedSurvey => selectedSurvey.code === row.original.code) ||
      props.pendingSurveyRequests.find(pendingSurvey => pendingSurvey.surveyCode === row.original.code);

    function onCheck(survey) {
      if (!isChecked) {
        setSelectedSurveys([...selectedSurveys, survey]);
      } else {
        const newSelection = selectedSurveys.filter(selected => selected !== survey);
        setSelectedSurveys(newSelection);
      }
    }

    const checkedClassnames = classnames('marketpay-survey-library__table-body-row', {
      checked: isChecked
    });

    return (
      <div className={checkedClassnames} key={`survey-${rowIndex}-${row?.original?.name}-${row?.original?.code}`}>
        <AdvancedCell>
          <CheckboxInput checked={isChecked} onClick={() => onCheck(row.original)} />
        </AdvancedCell>
        <AdvancedCell
          className="marketpay-survey-library-survey__table-body-cell"
          getCellProps={row.cells[0].getCellProps}
        >
          <p className="marketpay-survey-library-code__table-body-cell">{row?.original?.code}</p>
          <p className="marketpay-survey-library-name__table-body-cell">{row?.original?.name}</p>
          <div className="marketpay-survey-library-sublabel__table-body-cell">
            <SubLabelList
              subLabels={[
                { label: 'Geography', text: row?.original?.geography },
                { label: 'Industry', text: row?.original?.industry }
              ]}
            />
          </div>
        </AdvancedCell>
        <AdvancedCell getCellProps={row.cells[1].getCellProps}>
          <p className="marketpay-survey-library__table-body-cell-jobs">{row?.original?.numSurveyJobs}</p>
        </AdvancedCell>
        <AdvancedCell getCellProps={row.cells[2].getCellProps}>
          <p className="marketpay-survey-library__table-body-cell-participants">{row?.original?.numParticipants}</p>
        </AdvancedCell>
        <AdvancedCell getCellProps={row.cells[3].getCellProps}>
          <p className="marketpay-survey-library__table-body-cell-cuts">{row?.original?.numJobScopes}</p>
        </AdvancedCell>
        <AdvancedCell getCellProps={row.cells[4].getCellProps}>
          <p className="marketpay-survey-library__table-body-cell-date">
            {row?.original?.effDate ? moment(row?.original?.effDate).format('MMM Do YYYY') : ''}
          </p>
        </AdvancedCell>
      </div>
    );
  }

  function closeSelectedOverlay() {
    setSelectedSurveys([]);
  }

  function addSelectedSurveys() {
    props.onSurveyAdd(selectedSurveys).then(() => {
      closeSelectedOverlay();
      props.history.push('/market-analysis/survey-library/change-request');
    });
  }

  function showAddNewSurveyModal() {
    setShouldShowAddNewSurveyModal(true);
    props.resetAddSurveysError();
  }

  function closeAddNewSurveyModal() {
    setShouldShowAddNewSurveyModal(false);
    props.setNewSurveyName('');
    props.setSelectedPublisher(null);
  }

  function addNewSurvey(surveyName) {
    return props.onSurveyAdd([{ name: surveyName }]);
  }

  function handleReset() {
    props.handleReset();
    props.searchInputSearch('');
    setSearchText('');
  }

  const { facetItemClick, marketPaySurveyLibrarySearch, facetReset } = props;
  const tableClassNames = classnames('marketpay-survey-library-data__table', {
    'overlay-margin': !isIE() && selectedSurveys.length > 0
  });
  const showResetAllButton =
    Object.keys(props.marketPaySurveyLibrarySearch.exclude).length > 0 ||
    Object.keys(props.marketPaySurveyLibrarySearch.include).length > 0;

  return (
    <div className="marketpay-survey-library__container">
      <FacetPanel
        facets={marketPaySurveyLibrarySearch.facets}
        facetSelection={marketPaySurveyLibrarySearch.facetSelection}
        facetItemClick={facetItemClick}
        facetReset={facetReset}
        lastFacetFilteredID={marketPaySurveyLibrarySearch.lastFacetFilteredID}
        showFacetSectionSearch={true}
        className="marketpay-survey-library__facet-panel marketpay-survey-library__facets"
        innerClassName="marketpay-survey-library__facet-panel-inner"
        resetSearch={handleReset}
        isLoaded={true}
        limit={5}
        showResetButton={showResetAllButton}
        resetFacetText="Reset All"
        showZeros={marketPaySurveyLibrarySearch.showZeros}
      />
      <div className="marketpay-survey-library__content">
        <div className="master-survey-library__content-header">
          <div className="marketpay-survey-library__search-container">
            <h3 className="select-a-survey-to-r">Select a survey to request change</h3>
            <div className="marketpay-survey-library__search-row">
              <Search
                className="marketpay-survey-library__search"
                onChange={searchOnChange}
                onClick={searchOnClick}
                onKeyDown={searchOnKeyDown}
                onSearch={searchOnSearch}
                placeholder="Search by survey code, survey name, or survey publisher"
                value={searchText}
              />
              <div className="marketpay-survey-library__add-survey-container">
                <i className="marketpay-survey-library__add-icon icon-plus" />
                <h4 className="marketpay-survey-library__add-button" onClick={showAddNewSurveyModal}>
                  Add survey not in MarketPay library
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div className="master-survey-library__survey-list">
          {selectedSurveys.length > 0 && (
            <div className="selection__overlay">
              <div className="selection__text">
                {`${selectedSurveys.length} Selected`}
                <span className="selected-count__divider">|</span>
                <span className="add-selected-surveys__link" onClick={addSelectedSurveys}>
                  <i className="icon-plus" />
                  Add Selected Survey(s)
                </span>
              </div>
              <i className="icon-cancel" onClick={closeSelectedOverlay} />
            </div>
          )}
          <AdvancedTable
            useSelectAll={true}
            stickyHeader={true}
            staticTable={true}
            columnHeaders={columnHeaders}
            rowData={marketPaySurveyLibrarySearch.items}
            dataLoading={
              marketPaySurveyLibrarySearch.loading || props.isRetrievingPendingSurveys || props.isAddingSurveys
            }
            getDataRow={getTableRows}
            className={tableClassNames}
            headerClassName="marketpay-survey-library-data__table-header-cell"
          />
        </div>
        <div className="marketpay-survey-library__pagination-container">
          <Pagination
            className="marketpay-survey-library__pagination"
            offset={marketPaySurveyLibrarySearch.offset}
            step={marketPaySurveyLibrarySearch.limit}
            totalCount={marketPaySurveyLibrarySearch.searchResultsCount}
            pageAction={pageSurveys}
            prependText="Showing results for"
            middleText="surveys out of"
          />
        </div>
      </div>
      <AddNewSurveyModal
        show={shouldShowAddNewSurveyModal}
        onClose={closeAddNewSurveyModal}
        getPublishers={props.getPublishers}
        publishers={props.publishers}
        selectedPublisher={props.selectedPublisher}
        onPublisherClick={props.setSelectedPublisher}
        surveyName={props.newSurveyName}
        onSurveyNameChange={props.setNewSurveyName}
        onSurveyAdd={addNewSurvey}
        isAdding={props.isAddingSurveys}
        hasError={props.hasAddSurveysError}
      />
    </div>
  );
}

MarketPaySurveyLibrary.propTypes = {
  marketPaySurveyLibrarySearch: object,
  facetItemClick: func,
  facetReset: func,
  onAddSurvey: func,
  pendingSurveyRequests: array,
  isRetrievingPendingSurveys: bool,
  pageList: func,
  getPublishers: func,
  publishers: array,
  isRetrievingPublishers: bool,
  isRetrievingPublishersError: bool,
  selectedPublisher: string,
  setSelectedPublisher: func,
  setNewSurveyName: func,
  newSurveyName: string,
  isAddingSurveys: bool,
  hasAddSurveysError: bool,
  history: object,
  resetAddSurveysError: func,
  handleReset: func
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({}, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(MarketPaySurveyLibrary);
